import { LayersOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

type EnvironmentRibbonProps = {
  name: string
}

function EnvironmentRibbon({ name }: Readonly<EnvironmentRibbonProps>) {
  const { t } = useTranslation()

  if (!name) {
    return null
  }

  const environmentName = `${name.charAt(0).toUpperCase()}${name.slice(1)}`

  return (
    <Box
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.625,
        px: 1,
        height: 24,
        borderRadius: 1,
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1,
        letterSpacing: 0.2,
      })}
    >
      <LayersOutlined sx={{ fontSize: 14 }} />
      {environmentName} {t('common.environment')}
    </Box>
  )
}

export default EnvironmentRibbon
